import { __extends } from "tslib";
import { DeleteAppRequest, DeleteAppResponse } from "../models/index";
import { deserializeAws_restJson1DeleteAppCommand, serializeAws_restJson1DeleteAppCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteAppCommand = /** @class */ (function (_super) {
    __extends(DeleteAppCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteAppCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteAppCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DeleteAppRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteAppResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteAppCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1DeleteAppCommand(input, context);
    };
    DeleteAppCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1DeleteAppCommand(output, context);
    };
    return DeleteAppCommand;
}($Command));
export { DeleteAppCommand };
//# sourceMappingURL=DeleteAppCommand.js.map